export default __webpack_public_path__ + "static/media/Icon-Finanzen.7336963c.svg";